import { Button, Tooltip } from "@material-ui/core";
import React, { useMemo } from "react";
import Select, { components } from "react-select";
import { ValueType } from "react-select/src/types";

import { OwnerOption } from "../interfaces";

import { useAddOwnerFlow } from "./AddOwnerFlowContext";
import { MenuProps } from "react-select/src/components/Menu";

export function BoxOwnerSelector() {
    const {
        selectedOwnerId,
        setSelectedOwnerId,
        potentialOwnerOptions,
        loadingOwnerOptions,
        boxFeatures: {
            boxOwnerSelect,
            customerRegister,
        },
        setOpenNewCustomerDialog,
    } = useAddOwnerFlow();

    const selectedOption = useMemo(() => {
        if (selectedOwnerId === null) return null;
        return potentialOwnerOptions.find(it => it.value === selectedOwnerId)
    }, [potentialOwnerOptions, selectedOwnerId]);

    const menuFooterContent = customerRegister.enabled
        ? (
            <div style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                gap: "10px",
            }}>
                <span>Can't find?</span>
                <Button
                    variant="text"
                    onClick={() => setOpenNewCustomerDialog(true)}
                >
                    Register Owner
                </Button>
            </div>
        )
        : null;

    const OwnersMenu = (props: MenuProps<OwnerOption>) => (
        <components.Menu {...props}>
            <>
                <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                    {props.children}
                </div>
                {menuFooterContent && (
                    <div
                        style={{
                            padding: "8px",
                            borderTop: "1px solid #ddd",
                            fontSize: "12px",
                            textAlign: "center",
                            color: "#666",
                            background: "#fafafa",
                        }}
                    >
                        {menuFooterContent}
                    </div>
                )}
            </>
        </components.Menu>
    );

    return (
        <Tooltip title={boxOwnerSelect.reason}>
            <span>
                <Select
                    styles={{
                        container: (base) => ({
                            ...base,
                            minWidth: "200px",
                        }),
                        option: (base) => ({
                            ...base,
                            whiteSpace: "pre-wrap",
                        }),
                        menuList: (base) => ({
                            ...base,
                            maxHeight: "200px",
                        }),
                    }}
                    TextFieldProps={{ label: "Select Owner..." }}
                    options={potentialOwnerOptions}
                    isDisabled={!boxOwnerSelect.enabled || loadingOwnerOptions}
                    isLoading={loadingOwnerOptions}
                    value={selectedOption}
                    onChange={(value: ValueType<OwnerOption>) => {
                        const val = value as OwnerOption;
                        setSelectedOwnerId(val ? val.value : null);
                    }}
                    placeholder="Select Owner..."
                    components={{ Menu: OwnersMenu }}
                />
            </span>
        </Tooltip>
    );
}
